import { useRef, useEffect, useState } from "@wordpress/element";

// class = lei-product-attribute-range-filter
const RangeSlider = ({ name, min, max, value, step, onChange, onChangeEnd }) => {
    const ref = useRef();
    useEffect(() => {
        if (!value) return;   
        setTimeout(() => {
            const values = value.split("-").map(v => Number(v));
            //console.log("values", values)
            const slider = ref.current
            //slider.setAttribute('min', min);
            //slider.setAttribute('max', max);
            slider.value = values;
        }, 500);
    }, [ref, value])


    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        // Set initial value attribute
        el.setAttribute('value', value);
        el.setAttribute('name', name);

        const handleInput = (e) => {
            const val = e.target.value;
            onChange(val)    
        };

        const handleEnd = () => {
            const val = el.value; // Calls get value() from class
            onChangeEnd(val);
        };

        // React to custom element events
        el.addEventListener('range:input', handleInput);
        el.addEventListener('mouseup', handleEnd);
        el.addEventListener('touchend', handleEnd);

        return () => {
            el.removeEventListener('range:input', handleInput);
            el.removeEventListener('mouseup', handleEnd);
            el.removeEventListener('touchend', handleEnd);
        };
    }, [ref]);

       
    return (
        <range-slider
            ref={ref}
            min={min}
            max={max}
            name={name}
            value={value}
            step={step}
            style={{ display: 'block', width: '100%' }}
        />
    );
};

export default RangeSlider;
